const PUBLIC_KEY = "QBeDJy6fVnzcBPzsG";
export default PUBLIC_KEY;
